import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./includes/header";
import Footer from "./includes/footer";
import styles from "./../../assets/styles/_layout.module.scss";
import { useLocation } from "react-router-dom";

const Layout = () => {
  const location = useLocation();
  const hairChackPage = ["/hair-check"]; // list route need hide footer


  return (
    <div className={styles.main}>
      <div className={styles.bg}></div>
      <div className={styles.bgColor}></div>
      <div className={!hairChackPage.includes(location.pathname) ? styles.content : styles.hairCheckContent}>
        <Header />
        {/* Content */}
        <main>
          <Outlet />
        </main>

        {!hairChackPage.includes(location.pathname) && <Footer />}
      </div>
    </div>
  );
};

export default Layout;
